import firebase from "datastore/database";
import store from "datastore/store";

export default function observeBlockTables(businessUid) {
  store.dispatch({ type: "ADD_TABLE_BLOCKS_LOADING" });
  return firebase
    .firestore()
    .collection(`block-table/business/${businessUid}`)
    .orderBy("startDate")
    .onSnapshot((doc) => {
      let tables = [];
      doc.docs.forEach((doc) => tables.push({ uid: doc.id, ...doc.data() }));
      store.dispatch({ type: "ADD_TABLE_BLOCKS_SUCCESS", tables });
    });
}
